import { render, staticRenderFns } from "./ResetPasswordScreen.vue?vue&type=template&id=3414e606&scoped=true&"
import script from "./ResetPasswordScreen.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordScreen.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordScreen.vue?vue&type=style&index=0&id=3414e606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3414e606",
  null
  
)

export default component.exports